import { render, staticRenderFns } from "./CombinationText.vue?vue&type=template&id=036e2a12&scoped=true"
import script from "./CombinationText.vue?vue&type=script&lang=js"
export * from "./CombinationText.vue?vue&type=script&lang=js"
import style0 from "./CombinationText.vue?vue&type=style&index=0&id=036e2a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e2a12",
  null
  
)

export default component.exports